export const sortItems = [
    { id: 1, title: 'همه', status:'all' },
    { id: 2, title: 'منتشر شده' , status:'published' },
    { id: 3, title: 'منتشر نشده' , status:'unpublished' },
]